import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(1),
    width: "100vw",
    height: "92vh",
    padding: 10,
  },
  gridAuthorization: {
    width: "100%",
  },
  paddingB: {
    paddingBlock: 10,
  },
  paddingI: {
    paddingInline: 10,
  },
  error: {
    color: "red",
  },
  buttonReject: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.error.light,
    color: "white",
    width: "100%",
  },
  buttonApprove: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.light,
    width: "100%",
  },
  buttonExit: {
    backgroundColor: theme.palette.warning.light,
  },
  buttonsContainer: {
    marginTop: "24px",
  },
}));
